'use client'

import { motion } from 'framer-motion'
import { Clock, Zap, Calendar, MessageSquare } from 'lucide-react'

interface StepUrgenciaProps {
  onSubmit: (urgencia: '7_days' | '15_30_days' | 'negotiate') => void
  onBack: () => void
}

const OPCOES_URGENCIA = [
  { id: '7_days' as const, icon: Zap, label: 'Express - 7 dias', desc: 'Entrega super rapida', tag: 'Mais rapido' },
  { id: '15_30_days' as const, icon: Calendar, label: 'Normal - 15 a 30 dias', desc: 'Prazo padrao de desenvolvimento' },
  { id: 'negotiate' as const, icon: MessageSquare, label: 'A negociar', desc: 'Vamos conversar sobre prazos' }
]

export function StepUrgencia({ onSubmit, onBack }: StepUrgenciaProps) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="w-full max-w-md mx-auto">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-4 sm:mb-6">
        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center mx-auto mb-3 sm:mb-4 shadow-lg shadow-purple-500/30">
          <Clock size={24} strokeWidth={1.5} className="text-white" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-semibold text-indigo-950 dark:text-white mb-2">Para quando voce precisa?</h2>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="space-y-3">
        {OPCOES_URGENCIA.map((opt) => {
          const Icon = opt.icon
          return (
            <button key={opt.id} onClick={() => onSubmit(opt.id)} className="w-full p-4 rounded-xl border border-purple-500/20 dark:border-white/10 bg-white/85 dark:bg-white/5 hover:border-purple-500 hover:bg-purple-500/20 dark:hover:bg-purple-500/20 text-left transition-all relative">
              {opt.tag && <span className="absolute top-3 right-3 text-[10px] px-2 py-0.5 rounded-full bg-purple-500/20 text-purple-400 font-medium">{opt.tag}</span>}
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-lg bg-indigo-950/5 dark:bg-white/5 flex items-center justify-center"><Icon size={20} strokeWidth={1.5} className="text-indigo-950/60 dark:text-white/60" /></div>
                <div><h3 className="font-medium text-indigo-950 dark:text-white">{opt.label}</h3><p className="text-indigo-950/40 dark:text-white/40 text-sm">{opt.desc}</p></div>
              </div>
            </button>
          )
        })}
      </motion.div>
      <motion.button initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }} onClick={onBack} className="mt-6 w-full text-center text-sm text-indigo-950/40 dark:text-white/40 hover:text-indigo-950/60 dark:text-white/60 transition-colors">&larr; Voltar</motion.button>
    </motion.div>
  )
}
